import React from 'react'
import { Modal } from 'react-bootstrap'
import { Button } from '@abroad/components'

const ErrorModal = ({ show, onHide, message, title = 'Error' }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size='md'
      centered
      className='payment-modal'>
      <Modal.Header className='payment-modal-header d-flex justify-content-center border-0'>
        <h3 className='payment-modal-title mb-0'>{title}</h3>
      </Modal.Header>
      <Modal.Body className='payment-modal-body'>
        <div className='s6 text-center'>{message}</div>
      </Modal.Body>
      <Modal.Footer className='border-0 d-flex justify-content-end pt-0'>
        <Button
          variant='saffron'
          size='sm'
          className='px-3 text-uppercase'
          onClick={onHide}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ErrorModal
